import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // User management states
  users: [],
  profile: {},
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    // User management actions
    setUsers(state, action) {
      state.users = action.payload;
    },
    setProfile(state, action) {
      state.profile = action.payload;
    },
  },
});

export const { setUsers, setProfile } = globalSlice.actions;

export default globalSlice.reducer;
